import React from "react";
import DeviceInformationPreview from "../preview/DeviceInformationPreview";

const SecondaryDeviceInformationPreview = ({ deviceInformation }) => {
  return (
    <DeviceInformationPreview
      isPrimaryDevice={false}
      currentDevice={deviceInformation}
    />
  );
};

export default SecondaryDeviceInformationPreview;
